import React, { useState, useEffect, useRef } from 'react';
import { getLatestS3Image } from '../api/PublicIframe.api';
import '../styles/PublicIframe.css';

const PublicIframe = ({ feedId, label = 'Live image', refreshInterval = 5000 }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [imageDate, setImageDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const imgRef = useRef(null);
  const containerRef = useRef(null);

  const formatTime = (dateString) => {
    if (!dateString) return '--:--';
    const date = new Date(dateString);
    return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  };

  const fetchImage = async () => {
    try {
      setError(false);
      const data = await getLatestS3Image(feedId);
      setImageUrl(data.url);
      setImageDate(data.date);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching image:', err);
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!feedId) {
      setError(true);
      return;
    }
    fetchImage();
    const interval = setInterval(fetchImage, refreshInterval);
    return () => clearInterval(interval);
  }, [feedId, refreshInterval]);

  const handleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  const handleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await containerRef.current?.requestFullscreen();
        setIsFullscreen(true);
      } else {
        await document.exitFullscreen();
        setIsFullscreen(false);
      }
    } catch (err) {
      console.error('Fullscreen error:', err);
    }
  };

  return (
    <div className="lsl" id="lsl" ref={containerRef}>
      <img
        ref={imgRef}
        className={`lsl-img ${isZoomed ? 'zoomed' : ''}`}
        id="lslImg"
        alt="Live cam"
        data-full={imageUrl || ''}
        src={imageUrl || ''}
        style={{ objectFit: 'cover' }}
      />

      <div className="lsl-logo">
        <span className="lsl-mark"></span>
        {feedId !== 'liwkb09qt3j6' && <span>LISUAL</span>}
      </div>

      <div className="lsl-pill">
        Live image
        <span className="bars">
          <i></i>
          <i></i>
          <i></i>
        </span>
      </div>

      <div className="lsl-ctrl">
        <button
          className="lsl-btn"
          id="lslZoom"
          title="Ampliar"
          onClick={handleZoom}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="7"></circle>
            <path d="M21 21l-4.3-4.3M11 8v6M8 11h6"></path>
          </svg>
        </button>
        <button
          className="lsl-btn"
          id="lslFs"
          title="Pantalla completa"
          onClick={handleFullscreen}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4"></path>
          </svg>
        </button>
      </div>

      <div className="lsl-meta">
        <span className="lsl-label" id="lslLabel">
          {label}
        </span>
        <span className="lsl-stat">
          <span className="lsl-time" id="lslTime">
            {formatTime(imageDate)}
          </span>
          <span className="lsl-badge live" id="lslBadge">
            <span className="lsl-dot"></span>
            <span id="lslBadgeT">LIVE</span>
          </span>
        </span>
      </div>

      {loading && (
        <div className="lsl-cover" id="lslLoad">
          <div className="lsl-spin"></div>
          <small>Cargando</small>
        </div>
      )}

      {error && (
        <div className="lsl-cover" id="lslErr">
          <span className="ico">⚠</span>
          <small id="lslErrT">Sin señal</small>
        </div>
      )}
    </div>
  );
};

export default PublicIframe;
